/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs as  } from "relay-runtime";
export type ConversationModalContainer_comment = {
    readonly id: string;
    readonly rootParent: {
        readonly id: string;
    } | null;
    readonly parents: {
        readonly edges: ReadonlyArray<{
            readonly node: {
                readonly id: string;
                readonly " $fragmentRefs": FragmentRefs<"ConversationModalCommentContainer_comment">;
            };
        }>;
    };
    readonly parentCount: number;
    readonly " $fragmentRefs": FragmentRefs<"ConversationModalCommentContainer_comment">;
    readonly " $refType": "ConversationModalContainer_comment";
};
export type ConversationModalContainer_comment$data = ConversationModalContainer_comment;
export type ConversationModalContainer_comment$key = {
    readonly " $data"?: ConversationModalContainer_comment$data;
    readonly " $fragmentRefs": FragmentRefs<"ConversationModalContainer_comment">;
};



const node: ReaderFragment = (function () {
    var v0 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v1 = {
        "args": null,
        "kind": "FragmentSpread",
        "name": "ConversationModalCommentContainer_comment"
    } as any;
    return {
        "argumentDefinitions": [
            {
                "defaultValue": 1,
                "kind": "LocalArgument",
                "name": "count"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "cursor"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "connection": [
                {
                    "count": "count",
                    "cursor": "cursor",
                    "direction": "backward",
                    "path": [
                        "parents"
                    ]
                }
            ]
        },
        "name": "ConversationModalContainer_comment",
        "selections": [
            (v0 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": "CoralComment",
                "kind": "LinkedField",
                "name": "rootParent",
                "plural": false,
                "selections": [
                    (v0 /*: any*/)
                ],
                "storageKey": null
            },
            {
                "alias": "parents",
                "args": null,
                "concreteType": "CommentsConnection",
                "kind": "LinkedField",
                "name": "__ConversationModal_parents_connection",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "CommentEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "CoralComment",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    (v0 /*: any*/),
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "__typename",
                                        "storageKey": null
                                    },
                                    (v1 /*: any*/)
                                ],
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "cursor",
                                "storageKey": null
                            }
                        ],
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "PageInfo",
                        "kind": "LinkedField",
                        "name": "pageInfo",
                        "plural": false,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "hasPreviousPage",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "startCursor",
                                "storageKey": null
                            }
                        ],
                        "storageKey": null
                    }
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "parentCount",
                "storageKey": null
            },
            (v1 /*: any*/)
        ],
        "type": "CoralComment",
        "abstractKey": null
    } as any;
})();
(node as any).hash = 'e3949d67e8c410e128a423cfbd7685bb';
export default node;
